import React, { useState } from 'react';  
import Select, { createFilter }  from "react-select";
import { useEffect, useRef } from 'react';
import { useUpdateEffect } from '../../../hooks/useUpdateEffect'; 
   
const MultiSelect = ({ parentOptions, childOptions, parentId, childId, childIsMulti=false, styles, onChange, join, placeholder, placeholderSub, validate, validateMsg, validateSub, validateSubMsg, parentIsPerson, childIsPerson, fullWidth , topTitle, disabled = false, menuPortalTarget = false}) => {
    const hasDefaultParent = useRef(false);

    const [parents, setParents] = useState([]);
    const [childs, setChilds] = useState([]);  
    const [selectedParent, setSelectedParent] = useState(null);
    const [selectedChild, setSelectedChild] = useState(null);
    const [isClearable, setIsClearable] = useState(true);

    var filteredChilds = [];

    
    if (selectedParent && selectedParent.value) {
        filteredChilds = childs.filter( (child) => { 
           return child.parentId === selectedParent.value ;
        })
    } 

  

    useEffect(() => {   
        const parentMap = parentOptions.map((parent) => ({
            value: parent.id,
            label: parentIsPerson ? `${parent.firstname} ${parent.lastname}` : parent.name
        }));

        setParents(parentMap) 

        const childMap = childOptions.map((child) => ({
             value: child.id,  
             label: childIsPerson ? `${child.firstname} ${child.lastname}` : child.name, 
             parentId: child[join]}))


        setChilds(childMap)
 
        const foundParent = parentMap.find(parent => parent.value === parentId);
        const foundChild =  childMap.find(child => child.value === childId);
        setSelectedParent(foundParent)
        setSelectedChild(foundChild)

        console.log("found child", foundChild)
 
        hasDefaultParent.current = true;
    }, []);






    useUpdateEffect(() => {
         if (!hasDefaultParent.current) {
            setSelectedChild(null)  
          }  else {
            hasDefaultParent.current = false 
         }
    }, [selectedParent]);

 

    /*
        const onChildChange = (selectedOption) => {
            if (selectedOption) {
                onChange(selectedParent ? selectedParent.value : 0, selectedOption.value);
                setSelectedChild(selectedOption);
            } else {
                onChange(selectedParent ? selectedParent.value : 0, null); 
                setSelectedChild(null);
            }
        };
    */


    const onChildChange = (selectedOption) => {
        if (Array.isArray(selectedOption) && selectedOption.length > 0) { 
            const selectedValues = selectedOption.map((option) => option.value);
            onChange(selectedParent ? selectedParent.value : 0, selectedValues);
            setSelectedChild(selectedOption);
        } else if (selectedOption) { 
            onChange(selectedParent ? selectedParent.value : 0, selectedOption.value);
            setSelectedChild(selectedOption);
        } else { 
            onChange(selectedParent ? selectedParent.value : 0, null);
            setSelectedChild(null);
        }
    };



     const onParentChange = (selectedOption) => {
 
        if (selectedOption) { 
            onChange(selectedOption.value, selectedChild ? selectedChild.value : null);
            setSelectedParent(selectedOption);

        } else {
            onChange(null);  
            setSelectedParent(null);

        }
    };
 












    const stylesError = { 
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',  
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),  
    };

    const tileStyles = {  
            position: 'absolute',
            fontSize: '11px', 
            fontWeight: '500',
            color: 'var(--muted-text-color)', 
            lineHeight: 1, 
            marginBottom: '4px',
            top: '-6px',
            zIndex: '0',
            left: '8px', 
            padding: '0 3px',
            background:'#fff',
    };

    const tileStylesError = {  
            position: 'absolute',
            fontSize: '11px', 
            fontWeight: '500',
            color: 'rgb(225, 29, 72)', 
            lineHeight: 1, 
            marginBottom: '4px',
            top: '-6px',
            zIndex: '0',
            left: '8px', 
            padding: '0 3px',
            background:'#fff',
    };

    return (
        <div style={{ display: 'flex', gap:  fullWidth ? '12px' : '10px',  flexWrap: fullWidth ? "wrap" : "unset" }}>

            <div style={{ width: fullWidth ? "100%" : "50%", position: 'relative' }}>
                <Select
                    styles={validate && validate ? { ...styles, ...stylesError } : styles}
                    options={parents}
                    value={selectedParent}
                    onChange={onParentChange}
                    placeholder={placeholder}
                    filterOption={createFilter({ ignoreAccents: false })}
                    isClearable={isClearable}
                    isDisabled={disabled}
                    // ამ ფუნქციის გარეშე სხვა მოდალის უკან იშლება ამოსარჩევი ელემენტები 
                    // სადაც იბაგება გადაეცი  menuPortalTarget = { true}
                    menuPortalTarget={menuPortalTarget ? document.body : undefined}

                /> 

                {topTitle && <div style={validate && validate ? tileStylesError : tileStyles}>{placeholder}</div>}

                 {
                    validate && validateMsg &&
                    <div style={{ color: 'rgb(225, 29, 72)', fontSize: '12px' }}>{validateMsg} </div>
                }
            </div>


            <div style={{ width: fullWidth ? "100%" : "50%", position: 'relative' }}>
                <Select
                    styles={validateSub && validateSub ? { ...styles, ...stylesError } : styles}
                    options={filteredChilds}
                    value={selectedChild}
                    onChange={onChildChange} 
                    placeholder={placeholderSub}
                    isClearable={isClearable}
                    isMulti={childIsMulti}
                    isDisabled={disabled}
                    menuPortalTarget={menuPortalTarget ? document.body : undefined}
                />

                {topTitle && <div style={validateSub && validateSub ? tileStylesError  : tileStyles}>{placeholderSub}</div>}


                {
                    validateSub && validateSubMsg &&
                    <div style={{ color: 'rgb(225, 29, 72)', fontSize: '12px' }}>{validateSubMsg} </div>
                }
            </div>
        </div>
    );
};

 export default MultiSelect;